module.exports = __webpack_public_path__ + "static/img/ksa-certification-system.e271748.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ksa-certification-system.jpg
// module id = UEQj
// module chunks = 0